import React, { Component } from 'react';
import Postman from '../utils/service';
import { setCurrentUser } from "../actions/AuthActions";
import { configureStore } from '../store';
import jwt_decode from "jwt-decode";
import { setAuthToken } from '../utils/helper';
import Cookies from 'js-cookie';

class GoogleLogin extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    window.googleResponse = this.googleResponse
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

  }


  googleResponse = response => {
    {
      Postman.signInWithGoogle(response.credential, Cookies.get('landingPage'))
        .then(res => {
          const token = res.data.token
          localStorage.setItem("jwtToken", token);
          Cookies.set("token", token)
          setAuthToken(token);
          const decoded = jwt_decode(token);
          const store = configureStore();
          store.dispatch(setCurrentUser(decoded));
          window.location.href = res.data.returnUrl
        })
    }
  }


  render() {
    return (
      <React.Fragment>

        <div id="g_id_onload"
          data-client_id="3531177556-es7453n9vkauedm4fdudhebr1m3e536o.apps.googleusercontent.com"
          data-context="signup"
          data-ux_mode="popup"
          data-callback="googleResponse"
          data-auto_prompt="false">
        </div>

        <div className="g_id_signin"
          data-type="standard"
          data-shape="pill"
          data-theme="filled_blue"
          data-text="signup_with"
          data-size="large"
          data-logo_alignment="left"
          data-width="400"
          >
        </div>
      </React.Fragment >

    );
  }
}

export default GoogleLogin;



// WEBPACK FOOTER //
// ./client/src/components/GoogleLogin.js